import { cva } from '@/styled-system/css';

export const tableHeaderCellRecipe = cva({
  base: {},
  variants: {
    appearance: {
      bare: {
        borderBlockEndWidth: 'Table.Cell',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'Table.Cell.border',
      },
      horizontal: {},
      grid: {},
      zebra: {},
    },
    interactive: {
      true: {
        cursor: 'pointer',
        userSelect: 'none',
        position: 'relative',
        overflow: 'visible',

        _hover: {
          backgroundColor: 'Table.Cell.bg.hover',
          color: 'Table.Cell.text.hover',
        },

        _active: {
          backgroundColor: 'Table.Cell.bg.pressed',
          color: 'Table.Cell.text.pressed',
        },
      },
      false: {},
    },
    size: {
      sm: {
        textStyle: 'body-sm-bold',
      },
      md: {
        textStyle: 'body-sm-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
    sticky: {
      true: {
        position: 'sticky',
        top: 0,
      },
      false: {},
    },
  },
});
